import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Nav, Navbar, NavItem } from 'react-bootstrap'
import { Icon } from 'react-fa'
import logoImage from '../../static/img/Isha_logo-2x.png'
import { LinkContainer } from 'react-router-bootstrap'
import { Link } from 'react-router-dom'

export default class Navigation extends Component {
  static PropTypes = {
    path: PropTypes.string.required,
    authenticated: PropTypes.bool.required,
    setNavExpanded: PropTypes.func.required,
    navExpanded: PropTypes.bool.required,
    setNavState: PropTypes.func.required,
    closeNav: PropTypes.func.required,
    handleSearchRestartClick: PropTypes.func.required,
    handleDashboardClick: PropTypes.func.required,
    logout: PropTypes.func.required
  }

  render() {
    const {
      path,
      authenticated,
      setNavExpanded,
      navExpanded,
      setNavState,
      closeNav,
      handleSearchRestartClick,
      handleDashboardClick,
      logout,
      showRoomScreen
    } = this.props
    return (
      <Navbar
        inverse
        onToggle={setNavExpanded}
        expanded={navExpanded}
        onClick={setNavState}
      >
        <Navbar.Header>
          <Navbar.Brand>
            <Link to='/'>
              <img
                height={50}
                width={65}
                className='header-logo'
                src={logoImage}
              />{' '}
            </Link>
          </Navbar.Brand>
        </Navbar.Header>
        {!authenticated ? (
          <Nav className='accommodations-text'>
            <Navbar.Text>
              Adiyogi Darshan
              <br />
              <span style={{ fontSize: '15px' }}>
                At Isha Institute of Inner-sciences, USA
              </span>
            </Navbar.Text>
          </Nav>
        ) : null}
        {authenticated ? <Navbar.Toggle autoCollapse /> : null}
        {authenticated ? (
          <Navbar.Collapse onSelect={closeNav}>
            <Nav>
              <LinkContainer
                to='/'
                onClick={handleSearchRestartClick}
                isActive={() =>
                  path === '/' ||
                  path === '/search' ||
                  path === '/results' ||
                  path === '/guestentry' ||
                  path === '/payment'
                }
              >
                <NavItem>{authenticated ? 'Search' : 'Home'}</NavItem>
              </LinkContainer>
              <LinkContainer to='/dashboard' onClick={handleDashboardClick}>
                <NavItem>Dashboard</NavItem>
              </LinkContainer>

              {showRoomScreen && (
                <LinkContainer to='/rooms'>
                  <NavItem>Rooms</NavItem>
                </LinkContainer>
              )}
            </Nav>

            <Nav pullRight className='sign-in-out'>
              <NavItem onClick={logout}>
                Logout <Icon size='lg' name='angle-right' />
              </NavItem>
            </Nav>
          </Navbar.Collapse>
        ) : null}
      </Navbar>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/navigation.js